module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Send.6a84e4be.svg";